import React from "react";
import DimensionMap from "components/map/DimensionMap"
import DimensionService from "services/DimensionsService"
import AuthContext from 'store/AuthContext';

const MapPage: React.FC = () => {
    const containerRef = React.useRef<HTMLDivElement | null>(null);

    const authCtx = React.useContext(AuthContext)
    const [content, setContent] = React.useState<any>(null);

    const setContainerHeight = () => {
        if (!containerRef.current) {
            return;
        }

        const computedStyle = getComputedStyle(document.documentElement);
        const smallScreenSz = parseFloat(computedStyle.getPropertyValue('--small-screen').trim());
        const mobileHeaderSz = parseFloat(computedStyle.getPropertyValue('--dx-mobile-header-height').trim());

        const top = containerRef.current.getBoundingClientRect().top;
        const wh = window.innerHeight;
        const ww = window.innerWidth;
        const availableHeight = wh - top - (ww > smallScreenSz ? 0 : mobileHeaderSz);
        containerRef.current.style.height = `${availableHeight}px`;
    };

    const resizeCallback = () => {
        setContainerHeight()
        if (!containerRef.current) {
            const interval = setInterval(() => {
                if (containerRef.current) {
                console.log('map container is initialized:', containerRef.current);
                setContainerHeight();
                clearInterval(interval);
                }
            }, 100); // Check every 100 milliseconds
        
            return () => {
                clearInterval(interval);
            };
        }
    }

    React.useEffect(() => {
        setContainerHeight();
/*        
        authCtx.logAnalyticsEvent('WebMapView', {dimension: props.dimensionId})
        DimensionService.getMapContent(authCtx.account.getDimensionEnv(props.dimensionId), props.dimensionId, {})
        .then(data => {
            setContent(data)
        })
        .catch(error => {
            console.log(`No map content for dimension. Status: ${error}`)
        })
*/
        window.addEventListener('resize', resizeCallback);
        return () => {
            window.removeEventListener('resize', resizeCallback);
        };
    }, [])

    React.useEffect(() => {
        setContainerHeight();
    }, [containerRef]); // doesn't work for some reasons

    return <div ref={containerRef}>
        <DimensionMap dimensionId="1565156516"/>
    </div>

};

export default MapPage;
